import React from "react";
import { Button, Modal, Space, Typography } from "antd";
import image01 from "../../../../../imagens/imagens-instrucoes/mco-cadastrar-conta-bancaria-01.png";
import image02 from "../../../../../imagens/imagens-instrucoes/mco-cadastrar-conta-bancaria-02.png";
import image03 from "../../../../../imagens/imagens-instrucoes/mco-lancamentos-importar-ofx.png";
import image04 from "../../../../../imagens/imagens-instrucoes/mco-lancamentos-despesas-01.png";
import image05 from "../../../../../imagens/imagens-instrucoes/mco-lancamentos-despesas-02.png";
import { useState } from "react";
import TutorialModal from "../ModalTutorial";

const { Title, Paragraph } = Typography;

export default function InstrucaoModal({ open, onClose }) {

  const [openBanco, setOpenBanco] = useState(null); // controla o BancosModal

  return (
    <>
      <Modal
        title="Como lançar despesas e receitas importando o extrato bancário"
        open={open}
        onCancel={onClose}
        footer={null}
        width={900}
        destroyOnClose
        style={{ top: 20 }}
        className="premium-modal-v2"
        closable={true}
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 16 }}>
          <Typography>
            <Paragraph>
              Você pode lançar as despesas e receitas da sua empresa importando o
              extrato bancário no formato <strong>OFX (Open Financial Exchange)</strong>.
            </Paragraph>

            <Paragraph>
              Assim, você garante que as informações que estão no seu banco são as
              mesmas da sua contabilidade.
            </Paragraph>

            <Paragraph>
              O arquivo OFX carrega todas as transações financeiras de um período
              (valor, data, título, etc).
            </Paragraph>

            <Paragraph>
              ⚠️ O portal só aceita arquivos OFX no formato{" "}
              <strong>Money 2000</strong>.
            </Paragraph>
          </Typography>

          <Title level={4} style={{ marginTop: 24 }}>
            Importação de OFX para novas contas bancárias
          </Title>
          <Paragraph>
            Vá em: <strong>Financeiro &gt; Contas Bancárias &gt; Incluir Conta Bancária</strong>
          </Paragraph>
          <img src={image01} alt="Cadastrar conta bancária" style={imgStyle} />

          <Paragraph>Depois selecione o banco, digite a agência e a conta bancária:</Paragraph>
          <img src={image02} alt="Cadastrar conta bancária passo 2" style={imgStyle} />

          <Title level={4}>Importação de OFX para contas já cadastradas</Title>
          <Paragraph>
            Vá em <strong>Financeiro &gt; Lançamentos</strong>, clique em{" "}
            <strong>Importar</strong> e selecione o formato <strong>OFX</strong>.
          </Paragraph>
          <img src={image03} alt="Importar OFX" style={imgStyle} />

          <Paragraph>
            Depois disso, edite as classificações das movimentações financeiras
            atribuídas automaticamente pelo sistema, se necessário.
          </Paragraph>
          <img src={image04} alt="Editar despesas importadas" style={imgStyle} />
          <img src={image05} alt="Editar despesas importadas passo 2" style={imgStyle} />
        </div>
      </Modal>

      {/* Aqui abre o modal dos bancos */}
      {openBanco && (
        <TutorialModal
          openBanco={openBanco}
          onCloseBanco={() => setOpenBanco(null)}
        />
      )}
    </>
  );
}

const imgStyle = {
  width: "100%",
  borderRadius: 6,
  marginBottom: 20,
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
};
